const translations = {
    phoneNumberFieldLabel: 'PHONE NUMBER'
};

export default translations;
